import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core'
import { Integration } from 'src/app/account/services/account.service'

@Component({
  selector: '[account-integration]',
  templateUrl: './account-integration.component.html',
  styleUrls: ['./account-integration.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AccountIntegrationComponent {
  @Input() integration: Integration = null
  @Output() delete = new EventEmitter<null>()
  @Output() edit = new EventEmitter<null>()

  constructor() {}

  ngOnInit() {}

  editIntegration() {
    this.edit.emit()
  }

  deleteIntegration() {
    this.delete.emit()
  }
}
